import { isValidDate } from "./dates";

export function isMissing(value: string | null | undefined): value is null | undefined {
  return value === null || value === undefined;
}

/**
 * Code-unit order, a missing value last: ids, serials, type labels and
 * YYYY-MM-DD dates compare correctly this way and never depend on a locale.
 */
export function compareOrdinal(a: string | null | undefined, b: string | null | undefined): number {
  if (isMissing(a) || isMissing(b)) return Number(isMissing(a)) - Number(isMissing(b));
  if (a === b) return 0;
  return a < b ? -1 : 1;
}

/** Property names, a missing one last. */
export function compareNames(a: string | null | undefined, b: string | null | undefined): number {
  if (isMissing(a) || isMissing(b)) return Number(isMissing(a)) - Number(isMissing(b));
  return a.localeCompare(b);
}

/** A Go zero date is no date, as the status line reads it. */
export function dateOf(value: string | null | undefined): string | null {
  return isValidDate(value) ? value : null;
}
